import { defineStore } from 'pinia'


export const useSnackbarStore = defineStore({
  id: 'snackbar',
  state: () => ({
    data: {
      status:false,
      text: null,
      timeout: 2000
    }
  }),

  actions: {
    snackbar_reset() {
      Object.assign(this.data, {
        status:false,
        text: null,
        timeout: 2000
      })
 
    },
    snackbar_create(data) {
      Object.assign(this.data, data)
  
    }


  }
})
